import { createBrowserRouter } from 'react-router-dom';

// Layout
import MainLayout from '../layouts/MainLayout';

// Pages
import Home from '../pages/Home';
import About from '../pages/About';
import Classes from '../pages/Classes';
import Contact from '../pages/Contact';
import PrivateLessons from '../pages/Services/PrivateLessons';
import OutdoorLessons from '../pages/Services/OutdoorLessons';
import Exchange from '../pages/Services/Exchange';
import OnlineCourses from '../pages/Services/OnlineCourses';
import NotFound from '../pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <MainLayout />,
    errorElement: <NotFound />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: 'sobre',
        element: <About />,
      },
      {
        path: 'turmas',
        element: <Classes />,
      },
      {
        path: 'contato',
        element: <Contact />,
      },
      {
        path: 'servicos',
        children: [
          {
            path: 'aulas-particulares',
            element: <PrivateLessons />,
          },
          {
            path: 'ar-livre',
            element: <OutdoorLessons />,
          },
          {
            path: 'intercambio',
            element: <Exchange />,
          },
          {
            path: 'cursos-online',
            element: <OnlineCourses />,
          },
        ],
      },
    ],
  },
]);
